angular
  .module('app')
  .config(routesConfig);

/** @ngInject */
function routesConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');
  $urlRouterProvider.otherwise('/');

  $stateProvider
    .state('serverErrors', {
      url: '/serverErrors',
      component: 'serverErrors'
    })
    .state('booking', {
      abstract: true,
      url: '/{language:[a-zA-Z]{2}}/{userHash:[a-fA-F0-9]{32}}/{hotelId:[0-9]{1,2}}',
      component: 'bookingEngine',
      resolve: {
        hotelConfig: function (SettingService, $stateParams) {
          return SettingService.getHotelConfig($stateParams.userHash, $stateParams.hotelId, $stateParams.language);
        },
        bookingEngineConfig: function (SettingService, $stateParams) {
          return SettingService.getBookingEngineConfig($stateParams.userHash, $stateParams.hotelId, $stateParams.language);
        },
        categoriesList: function (SettingService, $stateParams) {
          return SettingService.getCategoriesList($stateParams.userHash, $stateParams.hotelId, $stateParams.language);
        },
        customerCss: function (SettingService, $stateParams) {
          return SettingService.getCustomerCss($stateParams.userHash, $stateParams.hotelId);
        }
      }
    })
    .state('booking.clientErrors', {
      url: '/clientErrors?code',
      component: 'clientErrors',
      resolve: {
        code: function ($stateParams) {
          return $stateParams.code;
        }
      }
    })
    .state('booking.offers', {
      url: '?checkIn&checkOut&occupancy&categoryId&discountCode&roomGroupId&rateplanId',
      component: 'offers'
    })
    .state('booking.guest', {
      url: '/step2?checkIn&checkOut&occupancy&cart&discountCode',
      component: 'guest'
    })
    .state('booking.payment-status', {
      url: '/payment-status?token}',
      component: 'paymentStatus'
    })
    .state('booking.payment-redirect', {
      url: '/payment-redirect}',
      component: 'paymentRedirect'
    });
}
